export default "../../src/img/lysiq-logo-simplified-3.svg";